import * as React from 'react';
import styled from 'styled-components';
import { ShadowOptions } from '../../theme';

const StyledImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`;

interface StyledImgWrapperProps {
    width: number;
    height: number;

    boxShadow: ShadowOptions;
    clickable: boolean;
}

const StyledImgWrapper = styled.div<StyledImgWrapperProps>`
    display: inline-block;
    position: relative;

    width: ${props => props.width}px;
    height: ${props => props.height}px;

    overflow: hidden;

    box-shadow: ${props => props.theme.shadows[props.boxShadow]};
    border-radius: ${props => props.theme.shape.borderRadius};

    ${props =>
        props.clickable &&
        `
        cursor: pointer;

        transition: all 0.3s ease-in-out;

        &:hover {
            ${props.boxShadow ? `box-shadow: ${props.theme.shadows[props.boxShadow + 1]}` : ''};
            transform: scale(1.05, 1.05);
        }
    `}
`;

export interface ThumbnailProps {
    children?: React.ReactNode;
    src: string;
    width?: number;
    height?: number;
    boxShadow?: ShadowOptions;
    onClick?: React.ImgHTMLAttributes<HTMLImageElement>['onClick'];
}

export const Thumbnail: React.FC<ThumbnailProps> = ({
    src,
    width = 200,
    height = width,
    boxShadow = 0,
    onClick,
    children,
}) => (
    <StyledImgWrapper boxShadow={boxShadow} clickable={!!onClick} height={height} width={width} onClick={onClick}>
        <StyledImg src={src} />
        {children}
    </StyledImgWrapper>
);
Thumbnail.displayName = 'Thumbnail';
